import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useHotkeys } from "react-hotkeys-hook";
import Modal from "react-modal";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { getUserNameStringWithCredentials } from "shared/utils/userUtils";

import { validOrderingDoctor } from "../dialogs/utils";

type PhysicianPreferencesModalProps = {
  caseDetailObject: CaseDetailState;
  isOpen: boolean;
  setPreferencesModal: Function;
};

export const show_clinic = (caseDetailObject: CaseDetailState) =>
  caseDetailObject.patient?.clinic?.phone ||
  caseDetailObject.patient?.clinic?.email ||
  caseDetailObject.clinic_preferences;

export const show_physician = (caseDetailObject: CaseDetailState) =>
  validOrderingDoctor(caseDetailObject.ordering_doctor) &&
  (caseDetailObject.ordering_doctor?.userprofile?.phone ||
    caseDetailObject.ordering_doctor?.email ||
    caseDetailObject.physician_preferences);

const PhysicianPreferencesModal = ({
  caseDetailObject,
  isOpen,
  setPreferencesModal,
}: PhysicianPreferencesModalProps) => {
  useHotkeys(
    "e",
    () => {
      setPreferencesModal(!isOpen);
    },
    { scopes: ["viewerHotkeys"] },
    [isOpen]
  );

  const EmailContact = ({ email }: { email?: string | null }) => {
    return email ? (
      <span>
        <FontAwesomeIcon icon={"envelope"} />
        <>&nbsp;</>
        <a href={`mailto:${email}`}>{email}</a>
      </span>
    ) : null;
  };
  const PhoneContact = ({ phone }: { phone?: string | null }) => {
    return phone ? (
      <span>
        <FontAwesomeIcon icon={"phone"} />
        <>&nbsp;</>
        <a href={`tel:${phone}`}>{phone}</a>
      </span>
    ) : null;
  };

  const Preferences = ({
    name,
    email,
    phone,
    preferences,
  }: {
    name?: string;
    email?: string | null;
    phone?: string | null;
    preferences?: string;
  }) => {
    return (
      <div>
        <dt>{name}</dt>
        <dd>
          {email && (
            <p>
              <EmailContact email={email} />
            </p>
          )}
          {phone && (
            <p>
              <PhoneContact phone={phone} />
            </p>
          )}
        </dd>
        {preferences && (
          <>
            <dt>Preferences</dt>
            <dd>
              {preferences.split("\n").map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </dd>
          </>
        )}
      </div>
    );
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => setPreferencesModal(false)}
      contentLabel="Physician Preferences"
      className="Modal"
      overlayClassName="Overlay"
    >
      <div className="PhysicianPreferencesModal">
        <dl>
          {show_physician(caseDetailObject) && (
            <Preferences
              name={
                caseDetailObject.ordering_doctor &&
                getUserNameStringWithCredentials(
                  caseDetailObject.ordering_doctor,
                  true
                )
              }
              email={caseDetailObject.ordering_doctor?.email}
              phone={caseDetailObject.ordering_doctor?.userprofile?.phone}
              preferences={caseDetailObject.physician_preferences}
            />
          )}
          {show_clinic(caseDetailObject) && (
            <Preferences
              name={caseDetailObject.patient?.clinic?.name}
              email={caseDetailObject.patient?.clinic?.email}
              phone={caseDetailObject.patient?.clinic?.phone}
              preferences={caseDetailObject.clinic_preferences}
            />
          )}
        </dl>
      </div>
    </Modal>
  );
};
export default PhysicianPreferencesModal;
